import React from 'react'

function DashBoardCard(props){
    return(
        <React.Fragment>
                <p className="p-3 text-center fw-6" style={{backgroundColor: "white"}}>{props.cardTitle}</p>
                <p className={"bg-transparent text-center align-middle fw-7 text-font"}>{props.count}</p>
        </React.Fragment>
    )
}

export default DashBoardCard